import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import Navbar from "./components/Navbar";
import HeroSection from "./components/HeroSection";
import VisionSection from "./components/VisionSection";
import ValueProposition from "./components/ValueProposition";
import HowItWorksSection from "./components/HowItWorksSection";
import ComparisonSection from "./components/ComparisonSection";
import WallOfLove from "./components/WallOfLove";
import PricingSection from "./components/PricingSection";
import DashboardSection from "./components/DashboardSection";
import TechArchitectureSection from "./components/TechArchitectureSection";
import VoicePipelineSection from "./components/VoicePipelineSection";
import SecurityEvolutionSection from "./components/SecurityEvolutionSection";
import IntegrationsSection from "./components/IntegrationsSection";
import FAQSection from "./components/FAQSection";
import CTASection from "./components/CTASection";
import Footer from "./components/Footer";
import CookieBanner from "./components/CookieBanner";

export default function HomePage() {
  const { hash } = useLocation();

  useEffect(() => {
    if (!hash) return;
    const id = hash.replace("#", "");
    const el = document.getElementById(id);
    if (el) {
      setTimeout(() => {
        el.scrollIntoView({ behavior: "smooth" });
      }, 100);
    }
  }, [hash]);

  return (
    <main className="w-full overflow-x-hidden">
      <Navbar />
      <HeroSection />
      <VisionSection />
      <ValueProposition />
      <HowItWorksSection />
      <ComparisonSection />
      <WallOfLove />
      <PricingSection />
      <DashboardSection />
      <TechArchitectureSection />
      <VoicePipelineSection />
      <SecurityEvolutionSection />
      <IntegrationsSection />
      <FAQSection />
      <CTASection />
      <Footer />
      <CookieBanner />
    </main>
  );
}
